"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import { useList } from '../../../../hooks/useList.mjs';
import SkeletonView from '../../../../../../views/SkeletonView.mjs';
import TextView from '../../../../../../views/TextView.mjs';
import { useLocalizedStringFormatter } from 'react-aria';
import locales from '../../../../../../../../_virtual/_.locale.json@8d5024994f97657f895a4e2a188d2d8a.mjs';

const PaginationInfos = (props) => {
  const stringFormatter = useLocalizedStringFormatter(locales);
  const list = useList();
  const pagination = list.batches;
  const isInitiallyLoading = list.loader.useIsInitiallyLoading();
  const isEmpty = list.useIsEmpty();
  const totalItemsCount = pagination.getTotalItemsCount();
  const visibleItemsCount = pagination.getVisibleItemsCount();
  if (isEmpty) {
    return null;
  }
  const text = isInitiallyLoading ? /* @__PURE__ */ jsx(SkeletonView, { width: "200px" }) : stringFormatter.format("list.paginationInfo", {
    visibleItemsCount,
    totalItemsCount
  });
  return /* @__PURE__ */ jsx(TextView, { ...props, children: text });
};

export { PaginationInfos, PaginationInfos as default };
//# sourceMappingURL=PaginationInfos.mjs.map
